/* Storefront guard only. Shipping-address enforcement belongs in checkout validation. */
(() => {
  const element = document.getElementById('ac-regional-plug-config');
  if (!element) return;
  const rules = JSON.parse(element.textContent);
  const matches = (handle, id) => !Object.hasOwn(rules.products, handle) || rules.products[handle].includes(String(id));
  const errorText = rules.plug === 'CONTACT'
    ? `Please contact us to confirm the right plug for ${rules.countryName} before ordering this robot.`
    : `${rules.plug} is required for ${rules.countryName}. Remove the other plug from your cart and add the matching plug before checkout.`;

  function correctUrl() {
    const picker = document.querySelector('variant-picker[update-url]:has([data-ac-locked-plug])');
    if (!picker) return;
    const variant = JSON.parse(picker.querySelector('script[data-variant]').textContent);
    if (!variant?.id) return;
    const url = new URL(location.href);
    if (url.searchParams.get('variant') !== String(variant.id) || url.searchParams.has('option_values')) {
      url.searchParams.set('variant', variant.id);
      url.searchParams.delete('option_values');
      history.replaceState(history.state, '', url);
    }
  }

  // Capture before the theme's product form handler and accelerated checkout click.
  function validateProduct(event, form) {
    const marker = form?.querySelector('[data-ac-regional-form]');
    if (!marker) return true;
    const id = form.elements.namedItem('id');
    const valid = id && matches(marker.dataset.productHandle, id.value);
    if (valid) return true;
    event.preventDefault();
    event.stopImmediatePropagation();
    form.dispatchEvent(new CustomEvent('cart:error', {bubbles: true, detail: {error: rules.plug === 'CONTACT' ? errorText : `Please reload this page to select ${rules.plug} for ${rules.countryName}.`}}));
    return false;
  }

  let checking = false;
  async function validateCheckout(event, control) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    control?.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, {cache: 'no-store', headers: {Accept: 'application/json'}});
      if (!response.ok) throw new Error('Cart could not be checked. Please try again.');
      const cart = await response.json();
      if (cart.items.some(item => !matches(item.handle, item.variant_id))) throw new Error(errorText);
      location.assign(`${window.Shopify.routes.root}checkout`);
    } catch (error) {
      const parent = control?.closest('form') || document.querySelector('main');
      let notice = parent?.querySelector('[data-ac-checkout-error]');
      if (!notice && parent) {
        notice = document.createElement('p');
        notice.className = 'banner banner--error';
        notice.style.cssText = 'display:block;min-width:0;overflow-wrap:anywhere;grid-column:1/-1';
        notice.dataset.acCheckoutError = '';
        notice.setAttribute('role', 'alert');
        notice.setAttribute('tabindex', '-1');
        parent.prepend(notice);
      }
      if (notice) {
        notice.textContent = error.message + ' ';
        const refresh = document.createElement('a');
        refresh.href = `${window.Shopify.routes.root}cart`;
        refresh.className = 'link';
        refresh.textContent = 'Review cart';
        notice.append(refresh);
        notice.focus();
      }
    } finally {
      checking = false;
      control?.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('submit', event => {
    if (!validateProduct(event, event.target)) return;
    if (event.submitter?.name === 'checkout') validateCheckout(event, event.submitter);
  }, true);
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    if (!target) return;
    if (target.closest('.shopify-payment-button')) validateProduct(event, target.closest('form'));
    const checkout = target.closest('a[href]');
    if (checkout && /\/checkout\/?$/.test(new URL(checkout.href).pathname)) validateCheckout(event, checkout);
  }, true);
  document.addEventListener('variant:change', correctUrl);
  addEventListener('pageshow', correctUrl);
  correctUrl();
})();
